export default __webpack_public_path__ + "static/media/ResetPass.707d7372.svg";